import { computed, makeObservable, observable } from "mobx";

import { Uuid } from "@/domains/global/identifiers";

export class AccountObservable {
  id: Uuid;
  profileEmailAddress: string;
  profileDisplayName: string;
  profilePhotoUrl: string | null;
  createdAt: string | null;

  constructor({
    id,
    profileEmailAddress,
    profileDisplayName,
    profilePhotoUrl,
    createdAt,
  }: {
    id: Uuid;
    profileEmailAddress: string;
    profileDisplayName: string;
    profilePhotoUrl: string | null;
    createdAt: string | null;
  }) {
    this.id = id;
    this.profileEmailAddress = profileEmailAddress;
    this.profileDisplayName = profileDisplayName;
    this.profilePhotoUrl = profilePhotoUrl;
    this.createdAt = createdAt;

    makeObservable(this, {
      id: observable,
      profileEmailAddress: observable,
      profileDisplayName: observable,
      profilePhotoUrl: observable,
      displayName: computed,
      secondaryLabel: computed,
      photoUrl: computed,
      createdAt: observable,
    });
  }

  get displayName() {
    return this.profileDisplayName;
  }

  get secondaryLabel() {
    return this.profileEmailAddress;
  }

  get photoUrl() {
    return this.profilePhotoUrl || undefined;
  }
}
